import React from "react";

// styles
import './partners.styles.css'

const Partners = () => {
  return (
    <div className="partners-container">
      <div className="partners-left">
        <h1>Our Partners</h1>
        <p>
          On our mission to build the home for crypto natives, we have the best
          networks as our partners. Flint currently supports Ethereum, Solana,
          Tron, and Binance Smart Chain with additional networks on the way.
        </p>
      </div>

      <div className="partners-right">
        

      </div>
    </div>
  );
};

export default Partners;
